import $ from "jquery";

const MODAL_SELECTOR       = "#cardInfoModal";
const MODAL_TITLE_SELECTOR = ".modal-title";
const MODAL_BODY_SELECTOR  = ".modal-body";

const setModalContent = function(modal, title, body) {
  modal.find(MODAL_TITLE_SELECTOR).text(title);
  modal.find(MODAL_BODY_SELECTOR).html(body);
};

const copyToClipboard = function (selector) {
  var input = document.querySelector(selector);
  input.focus();
  input.select();
  document.execCommand("copy");
  if ( document.selection ) {
    document.selection.empty();
  } else if ( window.getSelection ) {
    window.getSelection().removeAllRanges();
  }
};

const linkClicked = function(e) {
  e.preventDefault();

  const $card = $(this).closest("[data-card]");
  const $modal = $(MODAL_SELECTOR);
  const title = $($card.children()[0]).children(".card-title").text() || "Permalink";
  const body  = `
    <div>Click "Copy link" to copy a link to this card to the clipboard.</div>
    <div class="input-group">
      <input type="text" class="input-sm permalink-${$(this).parent().data("card-id")}" value="http://${window.location.host + $(this).parent().data("href")}" readonly="" />
      <div class="input-group-button">
        <button class="copy-permalink btn btn-primary" type="button">Copy link</button>
      </div>
    </div>
  `;

  setModalContent($modal, title, body);
  $(".copy-permalink").on("click", () => {
    copyToClipboard(`.permalink-${$(this).parent().data("card-id")}`);
  });
  $modal.modal("show");
};

const initPermalink = function() {
  $(".icon-card-permalink").on("click", linkClicked);
};

$(document).on("turbolinks:load", initPermalink);

export default initPermalink;
